// extracted by mini-css-extract-plugin
export default {"videoContainer":"Video_videoContainer__D2+uA","videoChu":"Video_videoChu__TaqVr"};